module.exports = __webpack_public_path__ + "static/img/product4.d6c8dac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yiBrand/red/product4.png
// module id = NpjD
// module chunks = 0